/** Availability `state` emitted by the endpoint while a day is still being computed. */
export const PENDING_STATE = 'pending';

/**
 * Decide whether a calendar day must be blocked (non-selectable).
 *
 * The `/search/calendar` endpoint returns, per day, both an `available` boolean
 * and a `state`:
 *   - `ready`       → has a min price (`available: true`).
 *   - `pending`     → no price yet, warmup/search still in progress or queued.
 *   - `unavailable` → no price and no pending warmup for that day.
 *
 * A day is blocked only when it is unavailable AND settled — i.e. `state` is
 * anything other than `pending`. While `pending`, the `available: false` is
 * provisional and is ignored, so the day stays selectable. On conforming data
 * this blocks exactly the `unavailable` days; `available` is kept in the
 * predicate as a safety net for a missing/unknown `state`.
 *
 * @param {{ available?: boolean, state?: string }} [day]
 * @returns {boolean} true → block the date (add it to the DayPicker `disabled` set)
 */
const isDateBlocked = (day) =>
  Boolean(day) && !day.available && day.state !== PENDING_STATE;

export default isDateBlocked;
